import produce from "immer";

export default function getMutableReducer(reducer) {
  return produce(reducer);
}
